<footer class="wvr-components wvr-footer bg-{{themeVariant}}">
  <nav class="navbar navbar-expand-lg">
    <div class="container">
      <div class="flex-fill align-self-stretch" footer-content>
        <ng-content select="template[footer-content]"></ng-content>
      </div>
    </div>
  </nav>
</footer>
